import { useMutation } from "@tanstack/react-query";
import { request } from "../../../services/axios.service";
import { apiUrls } from "../../api-urls";

const update = async (data: { _id: string; status: boolean }) => {
  const response: TServerResponse = await request({
    url: apiUrls.homeServices.UPDATE_SERVICE_STATUS,
    method: "POST",
    data,
  });
  return response;
};

export const useUpdateServiceStatusMutation = () => {
  return useMutation({ mutationFn: update });
};
